import PropTypes from 'prop-types';

export const userAudiobookProps = {
  id: PropTypes.string,
  archived: PropTypes.bool,
  playable: PropTypes.bool,
  playerUrl: PropTypes.string,
  progressStatus: PropTypes.string,
  positionPercent: PropTypes.number,
  audiobook: PropTypes.object, // should be audiobook prop shape, will open a card to sort out circular deps
  userReview: PropTypes.object,
};

export const userAudiobook = PropTypes.shape(userAudiobookProps);
